import React from 'react';
import * as Constants from '../constants'
import { useLookups, usePricing, usePhrasing } from "../hooks/useSkuUtils";
import { useStyles } from "../hooks/useStyles";
import { HeadingBuilder } from "./HeadingBuilder";
import { formatMoney } from '../utils'; 
import { useTranslation } from "react-i18next";

export const SkuFoundRow = ({ circle_id,
                            currency_symbol,
                            cstu,
                            otherSku,
                            showIdentifier,
                            showPostalCode,
                            showUnitCost,
                            showSkuDetailsColumn
                           }) => {
  console.log("sfr otherSkuA", circle_id, otherSku);

  const { t } = useTranslation();
  const { getUnitCost, chopParenS } = usePricing();
  const { tableOrderItem } = useStyles();
  const { weightAndUnitsOfSku, noDotZero, getOColTippyContent } = usePhrasing();
    
  const { lookup_category } = useLookups();

  const o_colTippyText      = getOColTippyContent({ isForTextNotAudio: true });
  const o_colAudioTippyText = getOColTippyContent({ isForTextNotAudio: false });

  const currency_subunit = cstu;

  const otherPriceFloat = 
    parseFloat(otherSku.shared_price)
      -  (parseFloat(otherSku.shared_discount_amount) || 0);

  const otherPrice = formatMoney({
                       currency_symbol,
                       currency_subunit,
                       amount:
                         otherSku.type === 'WeightyItem'
                           ? otherPriceFloat * otherSku.typical_weight
                           : otherPriceFloat,
                     });
  // $7.00

  const otherPriceTippyText =
    t('sku.price_date.searchLabel') + ' ' + otherSku.shared_price_date;
    // Price AsOf: 2024-05-21

  const otherPriceTippyInfoText =
    otherSku.shared_discount_amount > 0
      ? t('price.colHeader.normalPrice') + ": " +
          formatMoney({
            amount: otherSku.shared_price,
            currency_symbol,
            currency_subunit,
          }) + ' // ' +
          // "Normal price: $8.00 // "
        t('price.colHeader.discount') + ": " +
          formatMoney({
            amount: otherSku.shared_discount_amount,
            currency_symbol,
            currency_subunit,
          }) + ' // ' +
          // "Discount: $1.00 // "
        t('price.colHeader.discEnds') + ": " + otherSku.shared_discount_end_date
          // "Disc ends: 2024-05-30"
      : '';

  // checkbox advice per https://www.robinwieruch.de/react-checkbox/
  // button advice per https://www.robinwieruch.de/react-button/
  // https://upmostly.com/tutorials/pass-a-parameter-through-onclick-in-react
  return (
    <tr style={tableOrderItem}>

      {/* "O" button: */}
      <td>
        <HeadingBuilder
          tippyAlertText = {o_colTippyText}
          tippyAlertAudio= {o_colAudioTippyText}
          tippyText      = {o_colTippyText}
          blueLinkUrl    = {`/circles/${circle_id}/skus/${otherSku.uuuid}`}
          headingText    = {Constants.O_COL_SYM}
          // Click the O sign to choose that row's search results as the starting material for adding a new Sku to your Circle. Your Sku will need a Price and 'As Of' date for the Price.
        />
      </td>
      {/* ID */}
      <td>
        { showIdentifier
          ?
            otherSku.identifier.length > Constants.MAX_SKU_IDENTIFIER_CHARS_BEFORE_TIPPY
              ? < HeadingBuilder
                  containerType  = 'ellipsis fw-bold'
                  headingText    = {otherSku.identifier}
                  tippyAlertText = {otherSku.identifier}
                  tippyAlertIcon = {Constants.GET_ICON_ASTERISK}
                  tippyText      = {otherSku.identifier}
                />
              : <b>{otherSku.identifier}</b>
              
          : < HeadingBuilder
              headingText    = {Constants.DOT}
              // text of '.', which won't even display
              tippyAlertText = {otherSku.identifier}
              tippyAlertIcon = {Constants.GET_ICON_ASTERISK}
              tippyText      = {otherSku.identifier}
              forceShowAlertText = '1'
            />
        }
      </td>
      {/* Xip */}
      <td>
        { showPostalCode
          ?
            < HeadingBuilder
              headingText    = { (showIdentifier ? '-' : '') +
                                  otherSku.shared_circle_xip_code}
              // If 'identifier' is showing then '-' provides nice separation.
              // Otherwise, don't need to show the '-'.
              // 'countryCode' not needed - results are in same country. (Yes?)
              tippyInfoText  = {otherSku.shared_circle_identifier}
            />
              
          : < HeadingBuilder
              headingText    = {Constants.DOT}
              // text of '.', which won't even display
              tippyAlertText = {otherSku.shared_circle_xip_code}
              tippyAlertIcon = {Constants.GET_ICON_ASTERISK}
              tippyText      = {otherSku.shared_circle_xip_code}
              tippyInfoText  = {otherSku.shared_circle_identifier}
              forceShowAlertText = '1'
            />
        }
      </td>
      <td>{otherSku.brand}</td>
      <td>
        <HeadingBuilder
          containerType  = 'container-left'
          headingText    = {
            otherSku.label +
            weightAndUnitsOfSku({
              sku: otherSku,
              showWeightAsTswEditLink: false,
              showUnitCount: true,
              showQtyUnits: false
            }).join("")
          }
          tippyInfoText  = { lookup_category({category: otherSku.category}) }
          // e.g.: Milk, 1%, organic (qty 3) (!)
          // where 'tippyText' shows as 'Dairy'
          // After the label we'll show unit counts for multipack items and weight info for non-multipack items
        />
      </td>
      <td>{otherSku.store_label}</td>
      <td>
        {noDotZero({
          num:  
            otherSku.type === 'WeightyItem'
              ? otherSku.typical_weight
              : otherSku.quantity === 0
                ? ''
                : otherSku.quantity
                    })} {otherSku.units}
          {/* 13 lb */}
      </td>
      <td>
        <HeadingBuilder
          containerType  = 'oneline-container-right'
          headingText    = {otherPrice}
          // $7.00
          tippyAlertText = {otherPriceTippyText}
          tippyText      = {otherPriceTippyText}
          tippyInfoText  = {otherPriceTippyInfoText}
        />
        &nbsp;
      </td>
      {
        showUnitCost
          ? <td>
              { 
                getUnitCost ({
                  currency_symbol,
                  cstu,
                  sku: otherSku,
                  sku_price: otherPriceFloat
                })
              }
              /{chopParenS(otherSku.units)}
            </td>
          : null
      }
      <td>
        { showSkuDetailsColumn
          ? otherSku.detail
          : null
        }
      </td>
    </tr>
  )
}

export default SkuFoundRow;
